import React from 'react';
import { useNavigate } from 'react-router-dom';
import Hero from '../Hero/Hero';
import Features from '../Features/Features';
import Safety from '../Safety/Safety';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home">
      <Hero />
      <Features />
      <Safety />
      
      {/* Stats Section */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">55B+</span>
              <span className="stat-label">Matches Made</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">190+</span>
              <span className="stat-label">Countries</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">60B+</span>
              <span className="stat-label">Likes Sent</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">1.5M+</span>
              <span className="stat-label">Dates Weekly</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Start Something Epic</h2>
            <p className="cta-text">
              Ready to make meaningful connections? Join millions of people who have already found their match on Tinder.
            </p>
            <div className="home-cta-actions">
              <button className="btn btn-primary btn-lg" onClick={() => navigate('/find-love')}>
                Swipe Right Now
              </button>
              <button className="btn btn-lg home-cta-outline-btn" onClick={() => navigate('/find-love')}>
                Open Find Love
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
